import {Component, OnInit, OnDestroy} from '@angular/core';
import {SongsService, PlaylistService, AlbumsService, ScrollParams, ScrollService} from '../api';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import * as _ from 'lodash';
import {Helper} from '../helper';

@Component({
    selector: 'my-music-library',
    templateUrl: './my-music-library.component.html',
    styleUrls: ['./my-music-library.component.css']
})
export class MyMusicLibraryComponent implements OnInit, OnDestroy {
    public libraries: Array<any>;
    public librariesForCollectionView: Array<any>;
    private loading = true;
    private scrollParams = new ScrollParams();
    private scrollSubscriber = null;
    private searchTerm: string = '';
    private lastTerm: string = '';
    private limit: number = 10;
    private viewAsList = 1;
    private lyricSlice: number = 400;
    private helper = new Helper();
    private columnArr = [
        {
            title: 'add-to-discover',
            key: 'likeSource',
            type: 'icon',
            width: '80px',
            responsiveIndex: 'all'
        },
        {
            title: '',
            key: 'item.image',
            type: 'image',
            width: '80px',
            isSortable: true,
            responsiveIndex: 'all'
        },
        {
            title: 'Artist',
            key: 'item.artist.name',
            type: 'anchor',
            width: '170px',
            textStyle: ['my-music-artist'],
            responsiveIndex: 'gt-md'
        },
        {
            title: 'Name',
            key: 'item.name',
            type: 'anchor',
            width: '300px',
            textStyle: ['my-music-name'],
            responsiveIndex: 'all'
        },
        {title: 'Date', key: 'item.date', type: 'date', width: '100px', responsiveIndex: 'sm'},
        {title: 'Genres', key: 'item.genres', type: 'anchor', width: '', responsiveIndex: 'sm'},
        {title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '100px', responsiveIndex: 'sm'}
    ];
    private sortedColumn = null;
    public creditsArray: any = [];
    public writersArray: any = [];
    public onlineOffline: boolean = navigator.onLine;
    @BlockUI() blockUI: NgBlockUI;

    constructor(private songsService: SongsService, private playlistService: PlaylistService, private albumsService: AlbumsService, private scrollService: ScrollService, private router: Router, private route: ActivatedRoute) {
        window.addEventListener('online', () => {this.onlineOffline = true;});
        window.addEventListener('offline', () => {this.onlineOffline = false});
        this.libraries = new Array<any>();
        this.librariesForCollectionView = new Array<any>();
        this.scrollParams.page = 0;
        this.route.queryParams.subscribe((queryParams: any) => {
            if (typeof queryParams.q !== 'undefined') {
                this.searchTerm = queryParams.q;
            }
        });
        this.playlistService.myMusicCollectionID.subscribe(res => {
            if (res != 0) {
                let type = "libraries";
                this.libraries.splice(this.libraries.findIndex(obj => obj.item.id === res), 1);
            }
        });
    }

    ngOnInit() {
        if(screen.width > 767 && screen.width <= 1024 ) {
            this.columnArr = [
                {
                title: 'add-to-discover',
                key: 'likeSource',
                type: 'icon',
                width: '80px',
                responsiveIndex: 'all'
                },
                {
                    title: '',
                    key: 'item.image',
                    type: 'image',
                    width: '80px',
                    isSortable: true,
                    responsiveIndex: 'all'
                },
                {
                    title: 'Artist',
                    key: 'item.artist.name',
                    type: 'anchor',
                    width: '170px',
                    textStyle: ['my-music-artist'],
                    responsiveIndex: 'all'
                },
                {
                    title: 'Name',
                    key: 'item.name',
                    type: 'anchor',
                    width: '300px',
                    textStyle: ['my-music-name'],
                    responsiveIndex: 'all'
                },
                {title: 'Date', key: 'item.date', type: 'date', width: '100px', responsiveIndex: 'sm'},
                {title: 'Genres', key: 'item.genres', type: 'anchor', width: '', responsiveIndex: 'gt-md'},
                {title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '100px', responsiveIndex: 'sm'}];
        }
        if(screen.width < 768 ){
            this.columnArr = [
                {
                title: 'add-to-discover',
                key: 'likeSource',
                type: 'icon',
                width: '80px',
                responsiveIndex: 'all'
                },
                {
                    title: '',
                    key: 'item.image',
                    type: 'image',
                    width: '80px',
                    isSortable: true,
                    responsiveIndex: 'all'
                },
                {
                    title: 'Artist',
                    key: 'item.artist.name',
                    type: 'anchor',
                    width: '170px',
                    textStyle: ['my-music-artist'],
                    responsiveIndex: 'sm'
                },
                {
                    title: 'Name',
                    key: 'item.name',
                    type: 'anchor',
                    width: '300px',
                    textStyle: ['my-music-name'],
                    responsiveIndex: 'all'
                },
                {title: 'Date', key: 'item.date', type: 'date', width: '100px', responsiveIndex: 'sm'},
                {title: 'Genres', key: 'item.genres', type: 'anchor', width: '', responsiveIndex: 'sm'},
                {title: 'Rights', key: 'item.isSongDownloaded', type: 'rights', width: '100px', responsiveIndex: 'sm'}];
        }
        localStorage.setItem("radio", '0');
        this.libraries.length = 0;
        this.librariesForCollectionView.length = 0;
        this.getMusicLibrary();
        this.scrollService.toggleProgressBar(true);
        this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) => this.getMusicLibrary());
        if (localStorage.getItem("viewAsList") == "1") {
            this.viewAsList = 1;
        }
        if (localStorage.getItem("viewAsList") == "2") {
            this.viewAsList = 2;
        }
        if (localStorage.getItem("viewAsList") == "3") {
            this.viewAsList = 3;
        }
        if (screen.width <= 668) {
            this.lyricSlice = 400;
        } else if (screen.width <= 1400) {
            this.lyricSlice = 450;
        } else if (screen.width <= 3070) {
            this.lyricSlice = 550;
        } else {
            this.lyricSlice = 700;
        }
    }

    deleteLocal() {
        let type = "libraries";
        localStorage.removeItem(type);
        this.libraries = new Array<any>();
        this.librariesForCollectionView = new Array<any>();
        this.scrollParams.page = 0;
        this.getMusicLibrary();
    }

    getMusicLibrary() {
        localStorage.removeItem("libraries");
        localStorage.removeItem("librariesForCollectionView");
        console.log(localStorage.getItem("librariesForCollectionView"));
        console.log(localStorage.getItem("libraries"));
        let type = "libraries";
        if (this.lastTerm !== this.searchTerm) {
            this.resetScrollParams();
            this.lastTerm = this.searchTerm;
            this.libraries = new Array<any>();
            this.librariesForCollectionView = new Array<any>();
        }
        this.scrollService.toggleProgressBar(true);
        this.loading = true;
        if (this.localStore(type)) {
            if(this.onlineOffline == false)
                return ;
            this.songsService.loadUserMusicCollection(this.scrollParams, this.searchTerm, this.sortedColumn, this.limit).subscribe((res) => {
                if (res.length > 0) {
                    res.forEach((arrayItem) => {
                        if (arrayItem.domain) {
                            arrayItem.likedObject = arrayItem.object;
                            arrayItem.item.date = arrayItem.created_at;
                            arrayItem._type = arrayItem.item._type;
                            arrayItem.item.isSongDownloaded = ((!arrayItem.item.isSongDownloaded) ? 'Streaming' : 'Owned');
                            let genres = '';
                            if (arrayItem.item.genres) {
                                arrayItem.item.genres.forEach((genre, index) => {
                                    if (genres.length < 50) {
                                        genres += genre.name + ((index === arrayItem.item.genres.length - 1) ? '' : ',');
                                    }
                                });
                            }
                            arrayItem.item.genres = genres;
                            if (arrayItem.item.type != "P") {
                                if (arrayItem.item.lyrics != null) {
                                    arrayItem.item.songLyrics = arrayItem.item.lyrics;
                                    arrayItem.item.songLyrics2 = arrayItem.item.songLyrics.slice(0, this.lyricSlice);
                                }
                            }
                            this.librariesForCollectionView.push(arrayItem.item);
                            this.libraries.push(arrayItem);

                        }
                    });
                    this.scrollParams.page++;
                    this.librariesForCollectionView = _.uniqBy(this.librariesForCollectionView, 'id');
                    this.libraries = _.uniqBy(this.libraries, 'id');
                    // if(this.scrollParams.page<4){
                    //     this.getMusicLibrary()
                    // }
                } else {
                    this.scrollParams.recordsFinished = true;
                }
                this.removeSlash1(this.librariesForCollectionView);
                this.removeDuplicatCredits(this.librariesForCollectionView);
                this.removeSlash2(this.libraries);
                this.removeDuplicatCredits2(this.libraries);
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
                this.removeSlash();
                this.setLocalStore(type);
            });
        }
        if (!this.onlineOffline) {
            this.blockUI.stop();
            this.loading = false;
        }
    }

    localStore($type) {
        if (this.searchTerm != '') {
            return true;
        }
        if (this.sortedColumn != null) {
            return true;
        }
        let libraries = JSON.parse(localStorage.getItem($type));
        let librariesForCollectionView = JSON.parse(localStorage.getItem("librariesForCollectionView"));
        if (libraries != null && libraries.length > 0) {
            this.scrollParams.page = Math.ceil(libraries.length / this.limit);
            this.scrollParams.page++;
            this.playlistService.getCall().toPromise().then((res) => {
                this.libraries = libraries;
                this.librariesForCollectionView = librariesForCollectionView;
                this.removeSlash1(this.librariesForCollectionView);
                this.removeDuplicatCredits(this.librariesForCollectionView);
                this.removeSlash2(this.libraries);
                this.removeDuplicatCredits2(this.libraries);
                this.removeSlash();
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
                this.blockUI.stop();
            }).catch((err) => {
                this.libraries = libraries;
                this.librariesForCollectionView = librariesForCollectionView;
                this.removeSlash1(this.librariesForCollectionView);
                this.removeDuplicatCredits(this.librariesForCollectionView);
                this.removeSlash2(this.libraries);
                this.removeDuplicatCredits2(this.libraries);
                this.removeSlash();
                this.scrollService.toggleProgressBar(false);
                this.loading = false;
                this.blockUI.stop();
            });
            if(libraries.length<30) {
                return true;
            }
            return false
        } else {
            return true;
        }
    }

    removeSlash1(songs) {
        if(this.librariesForCollectionView){
            for(var i = 0 ;i<this.librariesForCollectionView.length;i++) {
                if (this.librariesForCollectionView[i]._type == "song") {
                    if (typeof this.librariesForCollectionView[i].credits === "object" && this.librariesForCollectionView[i].credits != null) {
                        for (var j = 0; j < this.librariesForCollectionView[i].credits.length; j++) {
                            this.librariesForCollectionView[i].credits[j].credit_type = this.librariesForCollectionView[i].credits[j].credit_type.replace("_", " ");
                            this.librariesForCollectionView[i].credits[j].credit_type = this.librariesForCollectionView[i].credits[j].credit_type.charAt(0).toUpperCase() + this.librariesForCollectionView[i].credits[j].credit_type.slice(1);
                        }
                    }
                }
            }
        }
    }

    removeDuplicatCredits(songs) {
        for(var i = 0 ; i<this.librariesForCollectionView.length; i++){
            if (this.librariesForCollectionView[i]._type == "song") {
                this.writersArray.length = 0;
                this.librariesForCollectionView[i].writers.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.librariesForCollectionView[i].writers[index]);
                        this.librariesForCollectionView[i].writers.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].writers.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.librariesForCollectionView[i].writers[index]);
                        this.librariesForCollectionView[i].writers.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].writers.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.librariesForCollectionView[i].writers[index]);
                        this.librariesForCollectionView[i].writers.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].writers.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.librariesForCollectionView[i].writers[index]);
                        this.librariesForCollectionView[i].writers.splice(index, 1);
                    }
                });
                this.creditsArray.length = 0;
                this.librariesForCollectionView[i].credits.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.librariesForCollectionView[i].credits[index]);
                        this.librariesForCollectionView[i].credits.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].credits.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.librariesForCollectionView[i].credits[index]);
                        this.librariesForCollectionView[i].credits.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].credits.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.librariesForCollectionView[i].credits[index]);
                        this.librariesForCollectionView[i].credits.splice(index, 1);
                    }
                });
                this.librariesForCollectionView[i].credits.forEach((item, index) => {
                    if (index !== this.librariesForCollectionView[i].credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.librariesForCollectionView[i].credits[index]);
                        this.librariesForCollectionView[i].credits.splice(index, 1);
                    }
                });
                if(this.creditsArray && this.creditsArray.length){
                    for(var j =0 ; j < this.creditsArray.length ; j++) {
                        for(var k = 0; k < this.librariesForCollectionView[i].credits.length ; k++){
                            if(this.librariesForCollectionView[i].credits[k].credit_type == this.creditsArray[j].credit_type){
                                if(!(this.librariesForCollectionView[i].credits[k].name.includes(this.creditsArray[j].name))){
                                    if(!this.librariesForCollectionView[i].credits[k].values){
                                        this.librariesForCollectionView[i].credits[k]["values"] = [];
                                    }
                                    if(!(this.librariesForCollectionView[i].credits[k].values.includes(this.librariesForCollectionView[i].credits[k].name))){
                                        this.librariesForCollectionView[i].credits[k].values.push(this.librariesForCollectionView[i].credits[k].name);
                                    }
                                    if(!(this.librariesForCollectionView[i].credits[k].values.includes(this.creditsArray[j].name))){
                                        this.librariesForCollectionView[i].credits[k].values.push(this.creditsArray[j].name);
                                    }
                                }
                            }
                        }
                    }
                }
                for(var k = 0; k < this.librariesForCollectionView[i].credits.length ; k++) {
                    if(!this.librariesForCollectionView[i].credits[k].values){
                        this.librariesForCollectionView[i].credits[k]["values"] = [];
                    }
                    if(!(this.librariesForCollectionView[i].credits[k].values.includes(this.librariesForCollectionView[i].credits[k].name))){
                        var locationPartt = this.librariesForCollectionView[i].credits[k].name.split(",");
                        for (var p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.librariesForCollectionView[i].credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if(this.librariesForCollectionView[i].credits[k].location && this.librariesForCollectionView[i].credits[k].location != null){
                        this.librariesForCollectionView[i].credits[k]["locations"] = [];
                        var locationParts = this.librariesForCollectionView[i].credits[k].location.split(",");
                        for(var m = 0; m < locationParts.length; m++ ){
                            if(!(locationParts[m].includes("."))){
                                this.librariesForCollectionView[i].credits[k].locations.push(locationParts[m]);
                            }
                            else{
                                var locationParts2 = locationParts[m].split(".");
                                for(var n = 0; n < locationParts2.length; n++ ){
                                    this.librariesForCollectionView[i].credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }

                //publisher array making
                if(!this.librariesForCollectionView[i].publishers) {
                    this.librariesForCollectionView[i]["publisherss"] = [];
                    if (this.librariesForCollectionView[i].publisher) {
                        var locationParttt = this.librariesForCollectionView[i].publisher.split(",");

                        for (var p = 0; p < locationParttt.length; p++) {
                            locationParttt[p].replace(",", "");
                            this.librariesForCollectionView[i].publisherss.push(locationParttt[p]);
                        }
                    }
                } else {
                    this.librariesForCollectionView[i]["publisherss"] = [];
                    for(let m = 0; m < this.librariesForCollectionView[i].publishers.length; m++){
                        if(this.librariesForCollectionView[i].publishers[m].publisher){
                            this.librariesForCollectionView[i].publisherss.push(this.librariesForCollectionView[i].publishers[m].publisher);
                        }
                    }
                }

            }
        }
    }

    removeSlash2(songs) {
        if(this.libraries) {
            for(var i = 0 ;i<this.libraries.length;i++) {
                if (this.libraries[i].item._type == "song") {
                    if (typeof this.libraries[i].item.credits === "object" && this.libraries[i].item.credits != null) {
                        for (var j = 0; j < this.libraries[i].item.credits.length; j++) {
                            this.libraries[i].item.credits[j].credit_type = this.libraries[i].item.credits[j].credit_type.replace("_", " ");
                            this.libraries[i].item.credits[j].credit_type = this.libraries[i].item.credits[j].credit_type.charAt(0).toUpperCase() + this.libraries[i].item.credits[j].credit_type.slice(1);
                        }
                    }
                }
            }
        }
    }

    removeDuplicatCredits2(songs) {
        for(var i = 0 ; i<this.libraries.length; i++){
            if (this.libraries[i].item._type == "song") {
                this.writersArray.length = 0;
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.libraries[i].item.writers.forEach((item, index) => {
                    if (index !== this.libraries[i].item.writers.findIndex(i => i.writer === item.writer)) {
                        this.writersArray.push(this.libraries[i].item.writers[index]);
                        this.libraries[i].item.writers.splice(index, 1);
                    }
                });
                this.creditsArray.length = 0;
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                this.libraries[i].item.credits.forEach((item, index) => {
                    if (index !== this.libraries[i].item.credits.findIndex(i => i.credit_type === item.credit_type)) {
                        this.creditsArray.push(this.libraries[i].item.credits[index]);
                        this.libraries[i].item.credits.splice(index, 1);
                    }
                });
                if (this.creditsArray && this.creditsArray.length) {
                    for (var j = 0; j < this.creditsArray.length; j++) {
                        for (var k = 0; k < this.libraries[i].item.credits.length; k++) {
                            if (this.libraries[i].item.credits[k].credit_type == this.creditsArray[j].credit_type) {
                                if (!(this.libraries[i].item.credits[k].name.includes(this.creditsArray[j].name))) {
                                    if (!this.libraries[i].item.credits[k].values) {
                                        this.libraries[i].item.credits[k]["values"] = [];
                                    }
                                    if (!(this.libraries[i].item.credits[k].values.includes(this.libraries[i].item.credits[k].name))) {
                                        this.libraries[i].item.credits[k].values.push(this.libraries[i].item.credits[k].name);
                                    }
                                    if (!(this.libraries[i].item.credits[k].values.includes(this.creditsArray[j].name))) {
                                        this.libraries[i].item.credits[k].values.push(this.creditsArray[j].name);
                                    }
                                }
                            }
                        }
                    }
                }
                for (var k = 0; k < this.libraries[i].item.credits.length; k++) {
                    if (!this.libraries[i].item.credits[k].values) {
                        this.libraries[i].item.credits[k]["values"] = [];
                    }
                    if (!(this.libraries[i].item.credits[k].values.includes(this.libraries[i].item.credits[k].name))) {
                        var locationPartt = this.libraries[i].item.credits[k].name.split(",");
                        for (var p = 0; p < locationPartt.length; p++) {
                            locationPartt[p].replace(",", "");
                            this.libraries[i].item.credits[k].values.push(locationPartt[p]);
                        }
                    }
                    if (this.libraries[i].item.credits[k].location && this.libraries[i].item.credits[k].location != null) {
                        this.libraries[i].item.credits[k]["locations"] = [];
                        var locationParts = this.libraries[i].item.credits[k].location.split(",");
                        for (var m = 0; m < locationParts.length; m++) {
                            if (!(locationParts[m].includes("."))) {
                                this.libraries[i].item.credits[k].locations.push(locationParts[m]);
                            }
                            else {
                                var locationParts2 = locationParts[m].split(".");
                                for (var n = 0; n < locationParts2.length; n++) {
                                    this.libraries[i].item.credits[k].locations.push(locationParts2[n]);
                                }
                            }
                        }
                    }
                }

                //publisher array making
                if (!this.libraries[i].publishers) {
                    this.libraries[i].item["publisherss"] = [];
                    if (this.libraries[i].item.publisher) {
                        var locationParttt = this.libraries[i].item.publisher.split(",");

                        for (var p = 0; p < locationParttt.length; p++) {
                            locationParttt[p].replace(",", "");
                            this.libraries[i].item.publisherss.push(locationParttt[p]);
                        }
                    }
                }else {
                    this.libraries[i]["publisherss"] = [];
                    for(let m = 0; m < this.libraries[i].publishers.length; m++){
                        if(this.libraries[i].publishers[m].publisher){
                            this.libraries[i].publisherss.push(this.libraries[i].publishers[m].publisher);
                        }
                    }
                }
            }
        }
    }

    removeSlash() {
        if(this.librariesForCollectionView){
            for(var i = 0 ;i<this.librariesForCollectionView.length;i++){
                if (this.librariesForCollectionView[i].type != "P"){
                    if(typeof this.librariesForCollectionView[i].credits === "object" && this.librariesForCollectionView[i].credits != null) {
                        for (var j = 0; j < this.librariesForCollectionView[i].credits.length; j++) {
                            this.librariesForCollectionView[i].credits[j].credit_type = this.librariesForCollectionView[i].credits[j].credit_type.replace("_", " ");
                            this.librariesForCollectionView[i].credits[j].credit_type = this.librariesForCollectionView[i].credits[j].credit_type.charAt(0).toUpperCase() + this.librariesForCollectionView[i].credits[j].credit_type.slice(1);
                        }
                    }
                }
            }
        }
    }

    setLocalStore($type) {
        if (this.searchTerm == '' && this.sortedColumn == null) {
            this.helper.setLocalStore($type, this.libraries);
            this.helper.setLocalStore("librariesForCollectionView", this.librariesForCollectionView);
        }
    }

    resetScrollParams() {
        this.scrollParams = new ScrollParams();
    }

    handleSearch(event) {
        this.searchTerm = event.searchTerm;
        let navigationExtras: NavigationExtras = {
            relativeTo: this.route,
            queryParams: {'q': this.searchTerm},
        };
        this.getMusicLibrary();
        this.router.navigate([], navigationExtras);
    }

    deleteFromLibrary(event) {
        _.remove(this.libraries, (arrayItem) => {
            return arrayItem.item.id === event.removed;
        });
    }

    sortColumn(event) {
        this.loading = true;
        this.scrollService.toggleProgressBar(true);
        this.sortedColumn = event;
        this.scrollParams = new ScrollParams();
        this.libraries = new Array<any>();
        this.getMusicLibrary();
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }

    toggleViewAsList(value) {
        this.viewAsList = value;
        localStorage.setItem("viewAsList", value);
        if (this.viewAsList == 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').className = 'app-content2';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content2';
            }
        }
        if(this.viewAsList != 3) {
            if (document.getElementById('Ui123456') != null) {
                document.getElementById('Ui123456').className = 'app-content';
            }
            if (document.getElementById('Ui12345') != null) {
                document.getElementById('Ui12345').className = 'app-content';
            }
        }
    }

    refreshList() {
        this.getMusicLibrary();
    }

    mouseHovering(index) {
        this.libraries[index].item.isHovering = true;
    }

    mouseLeaving(index) {
        this.libraries[index].item.isHovering = false;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-music-library/my-music-library.component.ts